var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[(_vm.getLoadingPage)?_c('div',{staticClass:"text-center py-5 my-5"},[_c('loader'),_vm._v(" "),_c('p',{staticClass:"body-2-4"},[_vm._v("Please wait...")])],1):[(_vm.cartPageType === 'ROOM')?_c('RoomCart'):_c('AdditionalCart')]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c44ab63","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/hotel/be/BeCartBase.vue
// module id = null
// module chunks = 